import type { CSSProperties } from 'react';
import variables from 'styles/variables.module.scss';

const { primaryColor } = variables;

/** The styles react-select passes to emotion, which also takes nested rules. */
interface ISelectStyle extends CSSProperties {
  '&:hover'?: CSSProperties;
  // Bug: a typo of `backgroundColor`, so the control keeps react-select's background.
  backroundColor?: string;
}

const SelectCustomStyles = {
  container: (style: CSSProperties): ISelectStyle => ({
    ...style,
    outline: 'none',
    borderBottom: '1px solid #adadad',
  }),
  control: (style: CSSProperties): ISelectStyle => ({
    // none of react-select's styles are passed to <Control />
    ...style,
    border: 'none',
    outline: 'none',
    borderRadius: 0,
    backroundColor: 'red',

    boxShadow: 'none',
    '&:hover': {
      outline: 'none',
    },
  }),
  dropdownIndicator: (style: CSSProperties): ISelectStyle => ({
    ...style,
    color: primaryColor,
  }),
  valueContainer: (style: CSSProperties): ISelectStyle => ({
    ...style,
    padding: 0,
    marginLeft: '-2px',
  }),
  singleValue: (style: CSSProperties): ISelectStyle => ({
    ...style,
    marginLeft: '2px',
  }),
  option: (style: CSSProperties): ISelectStyle => ({
    ...style,
    textAlign: 'left',
  }),
};

const featuresInputStyle = {
  display: 'inlineBlock',
  width: '90%',
};

export { featuresInputStyle, SelectCustomStyles };
